import Intercom from "@intercom/messenger-js-sdk";
import { useEffect } from "react";

// Module-level flag prevents Intercom from re-initialising on every mount.
// Multiple pages include this component; without the guard each route change
// would call Intercom() again, causing the widget to reinitialise.
let intercomInitialised = false;

export default function IntercomHelp() {
  useEffect(() => {
    if (intercomInitialised) return;
    intercomInitialised = true;
    Intercom({
      app_id: "vcd5eic2",
    });
  }, []);

  return <div />;
}
